const ATMOSPHERIC_TOKEN_PROPERTIES = Object.freeze({
  "app.background": "--theme-app-background",
  "app.backgroundAccent": "--theme-app-background-accent",
  "header.background": "--theme-header-background",
  "header.text": "--theme-header-text",
  "header.decorationTint": "--theme-header-decoration-tint",
  "sidebar.background": "--theme-sidebar-background",
  "sidebar.decorationTint": "--theme-sidebar-decoration-tint",
  "banner.background": "--theme-banner-background",
  "banner.text": "--theme-banner-text",
  "banner.border": "--theme-banner-border",
  "surface.soft": "--theme-surface-soft",
  "surface.decorative": "--theme-surface-decorative",
  "border.decorative": "--theme-border-decorative",
  "accent.decorative": "--theme-accent-decorative",
});

function isSupportedColor(value) {
  return (
    typeof value === "string" &&
    typeof CSS !== "undefined" &&
    CSS.supports("color", value)
  );
}

function apply(tokens = {}, root = document.documentElement) {
  reset(root);
  let appliedTokens = 0;
  Object.entries(tokens).forEach(([token, value]) => {
    const property = ATMOSPHERIC_TOKEN_PROPERTIES[token];

    if (property && isSupportedColor(value)) {
      root.style.setProperty(property, value);
      appliedTokens += 1;
    }
  });
  if (appliedTokens) {
    root.setAttribute("data-dynamic-theme", "true");
  }
}

function reset(root = document.documentElement) {
  Object.values(ATMOSPHERIC_TOKEN_PROPERTIES).forEach((property) => {
    root.style.removeProperty(property);
  });
  root.removeAttribute("data-dynamic-theme");
}

export default {
  apply,
  reset,
  supportedTokens: Object.keys(ATMOSPHERIC_TOKEN_PROPERTIES),
};
